import { useMutation } from 'react-query';
import { trpc } from '../../../../lib/trpc';

export default function useRemoveProductDocument() {
    return useMutation(async ({ documentId, entityId }: { documentId: number; entityId: number }) => {
        return trpc.ProductsApi.removeProductDocument.mutate({
            id: documentId,
            entityId,
        });
    });
}
